import { styled } from '@mui/system';
import { Dialog } from '@cw-ui/feedback-components';
import IconButton from '@mui/material/IconButton';
import { Box } from '@mui/material';

export const DialogTitle = styled(Dialog.Title)(() => ({
    paddingLeft: '16px',
}));

export const Icon = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.icon.iconPrimary,
}));

export const DialogContent = styled(Dialog.DialogContent)(() => ({
    padding: '0px 16px 0 16px',
}));

export const DialogContentL1 = styled(Dialog.DialogContentText)(() => ({
    marginBottom: '24px',
}));

export const DialogContentL2 = styled(Dialog.DialogContentText)(() => ({
    marginBottom: '16px',
}));

export const FileUploadContainer = styled(Box)(() => ({
    height: '240px',
    '[data-testid="helper-text"]': {
        display: 'none',
    },
}));

export const Actions = styled(Dialog.DialogActions)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: ' 0 16px 16px 16px',
}));
